<template>
  <div id="home">
    <HeaderView />
  </div>
  <HomeView />
  <div id="discography">
    <AlbumsView />
  </div>
  <div id="upcoming-shows">
    <UpcomingShows />
  </div>
  <div id="tour-2025">
    <TourView />
  </div>
  <div class="dotted-line"></div>
  <div class="footer-background">
    <footer>
    <div class="final-messages">
      <h3 class="footer-blurb">Thank you for visiting our corner of the virtual world.</h3>
      <img src="./assets/iso-babes-white.jpeg" class="footer-image" alt="The full six piece ensemble stands in white, smiling broadly and having fun.">
      <p>Please stay tuned for updates as we expand the Iso universe.</p>
      <p>Don't forget to follow us on social media for regular updates, show footage, album release updates, and more!</p>
    </div>
      <!-- <div class="social-media-bar footer-links">
        <a href="https://isolationtankensemble1.bandcamp.com/album/heliography" target="blank"><img src="./assets/icon-bandcamp2.png" class="nav-item nav-icon"></a>
        <a href="mailto:kirstyn.blandy@gmail.com"><img src="./assets/icon-contact.png" class="nav-item nav-icon"></a>
        <a href="https://soundcloud.com/isolationtankensemble" target="blank"><img src="./assets/icon-soundcloud.png" class="nav-item nav-icon"></a>
        <a href="https://www.instagram.com/isolationtankensemble/?hl=en" target="blank"><img src="./assets/icon-instagram.png" class="nav-item nav-icon"></a>
        <a href="https://www.facebook.com/isolationtankensemble/" target="blank"><div class="fb-step-off nav-item nav-icon">f</div></a>
        <a href="https://linktr.ee/isolationtankensemble" target="blank"><img src="./assets/lintree-logo.png" class="nav-item nav-icon"></a>
      </div> -->
      <SiteCredit />
      <div class="copyright">Website designed and owned by Isolation Tank Ensemble©</div>
  </footer>
  </div>
</template>

<script>
import HomeView from './components/HomeView.vue';
import HeaderView from './components/HeaderView.vue';
import AlbumsView from './components/AlbumsView.vue';
import UpcomingShows from './components/UpcomingShows.vue';
import TourView from './components/TourView.vue';
import SiteCredit from './components/SiteCredit.vue';

export default {
  name: 'App',
  components: {
    HomeView,
    HeaderView,
    AlbumsView,
    UpcomingShows,
    TourView,
    SiteCredit,
  }
}
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap');

#app 
  {
    font-family: "Space Mono", monospace;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #681012;
  }

html {
  background: url('../src/assets/tank-logo-gold-opaque.png') bottom right fixed no-repeat,
              url('../src/assets/abstract-gold(1).png') bottom center fixed no-repeat;
  background-color: rgba(255, 228, 196, 0.443);
  background-size: 100vh, 100vw;
  height: 100vh;
  width: 100vw;
  margin: 0;
}

a {
  padding: .5em;
  width: auto;
  text-decoration: none;
  /* gets rid of blue hyperlinks */
  color: inherit;
}

/* a:hover {
  background-color: #f09e8ca9;
} */
a:visited {
  text-decoration-line: none;
  font-style: none;
  color:rgb(63, 19, 91);
}
/* a:active {
  color:rgba(0, 255, 255, 0.363);
  text-decoration-line: none;
} */
ul {
  text-align: right;
}
li {
  list-style: none;
}

button {
  font-family: "Space Mono", monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  background-image: radial-gradient(#fbd485, #f09f8c, #ed3d85, #681012);
  border-radius: 22px;
  border-color: #ca8c2b;
  padding: 6px;
  margin: 1em;
  font-weight: bolder
}

button:active {
  background-image: radial-gradient(#fbd485, #ed3d85);
}

button:hover {
  background:#f09f8c;
}

p {
  background-color: #fff3e4f2;
  padding: 1em;
}

.copyright {
  text-align: center;
  background-color: #fff3e4f2;
}

.dotted-line {
  border-bottom: #681012 dotted 2px;
  margin: auto;
}

.footer-background {
  background-image: url('./assets/landscape.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-attachment: scroll;
}

.text {
  font-size: 1em;
}

.logo {
  margin: auto;
  width: 55%;
  margin-top: 1em;
}

.section-title {
  border-top: 2px dotted #681012;
  border-bottom: 2px dotted #681012;
  padding: 4px;
}

.footer-image {
  width: 80vw;
  width: 80vw;
  margin: auto;
}
.footer-links {
  text-align: center;
}

.final-messages {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer-blurb {
  text-align: center;
}
/* media queries */
@media only screen and (min-width: 500px) {
    .logo {
      width: 25%;
    }
  }

</style>
